import debug from 'debug';
import { e as entryMixin } from './index2.js';
import 'deepmerge';
import 'axios';
import 'vue';
import { _ as __vue_normalize__ } from './normalize-component.js';

//
var log = debug('xpedeo-core:ArEntry');
debug.enable(process.env.VUE_APP_DEBUG);
var script = {
  name: 'ArEntry',
  mixins: [entryMixin],
  mounted: function mounted() {
    var _this = this;

    if (this.$xp.device.isLoan) {
      log('in mounted in ArEntry, in Loan Device');
      var lastPage = this.$xp.history.historyArray[this.$xp.history.historyArray.length - 2];
      this.$xp.history.saveHistoryState();
      window.localStorage.setItem('shouldRestoreHistory', true);
      window.XpedeoAR.onBackButton(function (lastPage) {
        _this.$xp.history.restoreHistoryState();

        window.localStorage.setItem('shouldRestoreHistory', false);

        _this.$xp.history.back();

        log('onBackButton js callback, restoring History');
      }, function (error) {
        log('onbackButton callback error!', error);
      });
      var arUrl = this.$xp.settings.baseUrl + 'xpedeo/' + this.entryData.AR.Url;
      this.$xp.device.getRemappedUrl(arUrl).then(function (remappedUrl) {
        window.XpedeoAR.startSceneformWithUrl([lastPage.path, remappedUrl]);
      });
    } else {
      log('in ArEntry, not a Loan Device');
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "c-ar-entry" }, [
    _vm._m(0),
    _vm._v(" "),
    _vm.$xp.device.isLoan
      ? _c("div", { staticClass: "c-ar-entry__loading" }, [
          _c("i", { staticClass: "xp xp-spinner xp--large is-spinning" })
        ])
      : _c("div", { staticClass: "c-ar-entry__non-loan-warning" }, [
          _c("p", [
            _vm._v(
              "\n      " + _vm._s(_vm.$t("global.arNotAvailable")) + "\n    "
            )
          ])
        ])
  ])
};
var __vue_staticRenderFns__ = [
  function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "c-ar-entry__icon" }, [
      _c("span", { staticClass: "xp xp--huge xp-augmented_reality" })
    ])
  }
];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
